// Landing is fixed to a light palette regardless of app theme.
export const T = {
    page: "#F8FAFC",
    card: "#FFFFFF",
    text: "#0F172A",
    textMuted: "#475569",
    border: "#E2E8F0",
    primary: "#7C3AED",
    primaryHover: "#6D28D9",
    primarySoft: "#EDE9FE",
    accent: "#C4B5FD",
    success: "#15803D",
    successSoft: "#DCFCE7",
    warning: "#B45309",
    warningSoft: "#FEF3C7",
    danger: "#B91C1C",
    dangerSoft: "#FEE2E2",
};
